// Source/Product-Availability/Days.ts
var Day = 1000 * 60 * 60 * 24;
var Saturday = 6;
var Sunday = 0;
function inXDays(today, holidays) {
  const tod = timeOfDay(today);
  let delta = tod === "AM" ? 1 : 2;
  if (isInactive(today, holidays))
    delta = 1;
  let days = 0;
  const check = (date) => {
    delta--;
    days++;
    if (isInactive(date, holidays)) {
      delta++;
      delta = Math.min(delta, 1);
    }
    if (delta)
      check(new Date(date.getTime() + Day));
  };
  check(new Date(today.getTime() + Day));
  const date = new Date(today.getTime() + days * Day);
  return { days, date };
}
function isInactive(date, holidays) {
  const weekday = date.getUTCDay();
  if ([Saturday, Sunday].includes(weekday))
    return true;
  for (const holiday of holidays) {
    if (date.getUTCFullYear() !== holiday.getUTCFullYear())
      continue;
    if (date.getUTCMonth() !== holiday.getUTCMonth())
      continue;
    if (date.getUTCDate() !== holiday.getUTCDate())
      continue;
    return true;
  }
  return false;
}
function timeOfDay(date) {
  const minutes = date.getUTCMinutes();
  let hours = date.getUTCHours();
  if (minutes > 0)
    hours++;
  const noon = hours > GermanyHoursToUTC(13);
  return noon ? "PM" : "AM";
}
function GermanyHoursToUTC(hours) {
  return hours - 2;
}

// Source/Product-Availability/Component.ts
class ProductAvailability extends HTMLElement {
  connectedCallback() {
    if (!this.relevant)
      return;
    const { now } = this;
    const { days, date } = inXDays(now, this.holidays);
    const tomorrow = days === 1;
    this.time = tomorrow ? "Tomorrow" : "Later";
    this.day = date.toLocaleDateString(this.locale, { weekday: "long" });
    this.date = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }
  get locale() {
    return this.dataset.locale;
  }
  get relevant() {
    return !!this.querySelector(`[ data-insert ]`);
  }
  set time(value) {
    this.dataset.time = value;
  }
  set date(value) {
    this.setInsert("Date", value);
  }
  set day(value) {
    this.setInsert("Day", value);
  }
  get holidays() {
    const holidays = this.dataset.holidays;
    const days = JSON.parse(holidays) ?? [];
    return days.map((day) => new Date(day));
  }
  get now() {
    const now = this.dataset.now || Date.now();
    return new Date(now);
  }
  setInsert(type, value) {
    this.querySelectorAll(`[ data-insert = '${type}' ]`).forEach((element) => element.innerText = value);
  }
}

// Source/Product-Availability/Tests.ts
var Holidays = [
  new Date(`2025-08-11T18:32:47.635Z`)
];

// Source/Product-Availability/mod.ts
customElements.define("product-availability", ProductAvailability);
